<template>
<body style="background-color:#D6D6D6">
    <div >

        <v-container>
            <!--<h1 class="pl-5 ml-4 pt-5" style="color:#942C75; font-family:Poppins; font-size:1.8vw; font-weight:500">{{title}}</h1>-->
            <!--<v-layout row wrap>
            <v-flex sm4 md4 lg3 class="pl-4 ml-4 pt-5" >
            <v-card style="background-color:#4D93A8">
              <v-card-title><span class="titlecuentos" style="color:white; font-family:Poppins;  font-weight:600">CUENTOS</span></v-card-title>
            </v-card>
            </v-flex>
            <v-flex md1 class="pt-5" >
            <v-card flat style="background-color:#D6D6D6">
              <img src="cuentos.png"  style="position:absolute;margin-left:-30px; margin-top:-2px" />
            </v-card>
            </v-flex>
            </v-layout>-->
            <ContentCuentos :cuentos="cuentos" title="CUENTOS">
            </ContentCuentos>
            
       </v-container>
         

    </div>
    </body>
</template>


<script>
import ContentCuentos from "@/components/ContentCuentos.vue"

export default {
   
    components:{
       ContentCuentos
     },

    data(){
        return{
            cuentos:[
          
          {title:"Lala y Lily Lalabumers",img:"cuento1.png",url:"../descargas/files/cuentos/Cuento_Lalo_y_Lily_Lalabumers.pdf",namedownload:"Lalo_y_Lily"},
          {title:"Una solución Lalabum",img:"cuento2.png",url:"../descargas/files/cuentos/Cuento_Una_Solucion_Lalabum.pdf",namedownload:"Solucion_Lalabum"},
          {title:"Bum Bum precaución Lalabum",img:"cuento3.png",url:"../descargas/files/cuentos/Cuento_Bum_bum_precaucion_Lalabum.pdf",namedownload:"Precaucion_Lalabum"},
          {title:"Energía Lalabumer en tu día",img:"cuento4.png",url:"../descargas/files/cuentos/Cuento_Energia Lalabumer_en_tu_dia.pdf",namedownload:"Energia_Lalabumer"},
          {title:"Soy un campeón Lalabum",img:"cuento5.png",url:"../descargas/files/cuentos/Cuento_soy_un_campeon_Lalabum.pdf",namedownload:"Campeon_Lalabum"},
          {title:"Cuidando el medio ambiente",img:"cuidando_el_medio_ambiente.png",url:"../descargas/files/cuentos/Cuento_cuidando_el_medio_ambiente.pdf",namedownload:"Cuidando_el_medio_ambiente"},
          {title:"¡Lo siento fue un accidente!",img:"fue_un_accidente.png",url:"../descargas/files/cuentos/Cuento_Lo_siento_fue_un_accidente.pdf",namedownload:"Lo_siento_fue_un_accidente"},
          {title:"Se vale decir no",img:"se_vale_decir_no.png",url:"../descargas/files/cuentos/Cuento_se_vale_decir_no.pdf",namedownload:"Se_vale_decir_no"},
          {title:"Enfrentando a mi bully",img:"enfrentando_mi_bully.png",url:"../descargas/files/cuentos/cuento_enfrentando_a_mi_bully.pdf",namedownload:"Enfrentando_a_mi_bully"},
          {title:"Lalo y la hora de comer",img:"la_hora_de_comer.png",url:"../descargas/files/cuentos/Cuento_Lalo_y_la_hora_de_comer.pdf",namedownload:"Lalo_y_la_hora_de_comer"},
          {title:"La fiesta sorpresa de Andy",img:"fiesta_sorpresa_de_Andy.png",url:"../descargas/files/cuentos/Cuento_la_fiesta_sorpresa_de_Andy.pdf",namedownload:"La_fiesta_sorpresa_de_Andy"},
          {title:"Me das agua por favor",img:"me_das_agua_porfavor.png",url:"../descargas/files/cuentos/Cuento_me_das_agua_por_favor.pdf",namedownload:"Me_das_agua_por_favor"},
          {title:"Lucy no fue obediente",img:"lucy_no_fue_obediente.png",url:"../descargas/files/cuentos/Cuento_Lucy_no_fue_obediente.pdf",namedownload:"Lucy_no_fue_obediente"},
          {title:"Emma visita el supermercado",img:"emma_en_supermercado.png",url:"../descargas/files/cuentos/Cuento_Emma_visita_el_supermercado.pdf",namedownload:"Emma_visita_el_supermercado"},
          {title:"El domingo de Shanty",img:"domingo_shanty.png",url:"../descargas/files/cuentos/Cuento_El_domingo_de_Shanty.pdf",namedownload:"El_domingo_de_Shanty"},
          {title:"Los horarios de Lucy",img:"horarios_de_lucy.png",url:"../descargas/files/cuentos/Cuento_Los_horarios_de_Lucy.pdf",namedownload:"Los_horarios_de_Lucy"},

         
          
        ]
        }
    }
}
</script>

<style scoped>
.actividad.cuento{
    background-color:#4D93A8; 
    color: white;
    font-family: "Poppins";
    font-weight: 500;
    font-size: 1.5vw; 
    height: 60px;
  }

  @media (min-width: 1200px){
    .titlecuentos{
      font-size:1.2vw;
    }
  }
</style>


